export default "__VITE_PUBLIC_ASSET__398cf69b__"